import { render, staticRenderFns } from "./ContentDetails.vue?vue&type=template&id=5998f381&scoped=true&"
import script from "./ContentDetails.vue?vue&type=script&lang=ts&"
export * from "./ContentDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ContentDetails.vue?vue&type=style&index=0&id=5998f381&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5998f381",
  null
  
)

export default component.exports